import Spinner from "@material-tailwind/react/components/Spinner";

function Loader() {
  return (
    <div className="h-full w-full absolute right-0 top-0 flex bg-white z-[var(--loader-zIndex)] dark:bg-shades-dark items-center justify-center">
      <Spinner className="h-12 w-12" />
    </div>
  );
}

export default Loader;
